import { useEffect } from "react";
import { toast } from "sonner";
import { getLocale, setLocale, wasAutoDetected } from "@/lib/i18n";

const BANNER_KEY = "fev.autoLocaleBannerShown";
const TOAST_ID = "fev-auto-locale-nudge";

/**
 * Renders nothing. On first mount, if the current locale was auto-detected as FR
 * (i.e. the user has never explicitly picked a language), fire a small sonner
 * toast for ~5 seconds offering a one-tap switch to English. Shown once per browser.
 */
export const AutoLocaleBanner = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    let shown = false;
    try { shown = !!localStorage.getItem(BANNER_KEY); } catch { /* private mode */ }
    if (shown) return;
    if (!wasAutoDetected()) return;
    if (getLocale() !== "fr") return;

    // Slight delay so Toaster mounts and React StrictMode double-effects don't stack.
    const t = setTimeout(() => {
      toast("Site auto-détecté en français — Prefer English?", {
        id: TOAST_ID,
        duration: 6000,
        action: {
          label: "Switch to English",
          onClick: () => {
            setLocale("en");
            try { localStorage.setItem(BANNER_KEY, "1"); } catch { /* noop */ }
          },
        },
      });
      setTimeout(() => {
        try { localStorage.setItem(BANNER_KEY, "1"); } catch { /* noop */ }
      }, 6500);
    }, 400);

    return () => clearTimeout(t);
  }, []);

  return null;
};
